/*eslint-disable prefer-const */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Component, useState, useEffect, createRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
//import axios from 'axios';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { Container, Card, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { CoveragesSVG } from '../../img/tab_icons/CoveragesSVG';
import { ClaimsSVG } from '../../img/tab_icons/ClaimsSVG';
import { AccountsSVG } from '../../img/tab_icons/AccountsSVG';
import { IDCardSVG } from '../../img/tab_icons/IDCardSVG';
import { DocumentsSVG } from '../../img/tab_icons/DocumentsSVG';
import { ProfileSVG } from '../../img/tab_icons/ProfileSVG';
import CookiesService from '../../shared/CookiesService';
import APIEndpoints from '../../api/APIEndpoints';
import HttpErrorHandler from '../../errorhandling/HttpErrorHandler';

import RetryAPI from '../../api/RetryAPI';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../errorhandling/HttpErrorCodes';
import './member.scss';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ClientError from '../../errorhandling/ClientError';
import CustomError from '../../errorhandling/CustomError';
import MasterPermissions from '../../api/MasterPermissions';
//import { getCall } from '../../utils/axios';
import { axiosInstance } from '../../../api/axios';
import AllMemberDetailsSkeleton from './Skeleton/AllMemberDetailsSkeleton';
import { setSelectedMember } from '../../../redux/admin/memberModule';

import { capitalizeFirstLetter } from '../../utils/strings';
import {
  resetActiveUser,
  resetClaimsResult,
  resetSearchParams,
} from 'src/redux/admin/claimsSlice';
import CustomClientError from '../../errorhandling/CustomClientError';
import UserDefinedLabels from '../../utils/UserDefinedLabels';
import { AccumulatorSVG } from 'src/Admin/img/tab_icons/AccumulatorSVG';
import { getMemberDetailsByOidAndType } from 'src/redux/admin/api-calls/members';
import Feature from '../../../services/feature';
import { USER_TYPES } from 'src/constants';
import { ActionMenus } from './ActionMenus';
import store from 'src/redux/store';

let response = null,
  getUserResponse = null,
  getUserDataResp = null;
const AllMemberDetailsInfo = (props) => {
  console.log('AllMemberDetailsInfo :::::::::::: ', props);
  const memberActionMenusRef = createRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const noValue = 'Not Specified';
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const [loadingGetUser, setLoadingGetUser] = useState(true);
  const [clientError, setClientError] = useState(false);
  const [serverError, setServerError] = useState(false);
  const [customError, setCustomError] = useState(false);
  const [memberID, setMemberID] = useState('');
  const [isAccountsVisible, setisAccountsVisible] = useState(false);
  const [isDocumentVisible, setIsDocumentVisible] = useState(false);
  const [isBenefitAccumsVisible, setIsBenefitAccumsVisible] = useState(false);
  const { userData = {} } = useSelector((state) => state.user || {});
  const { Features_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const { DefaultMemberIDKey } = UserDefinedLabels();
  const FEATURES = Features_Setting;

  let viewClaim = false;
  let txnDetails = false;
  let viewCoverage = false;
  let viewMemRec = false;
  let viewIdCards = false;
  let viewDocument = false;
  let viewProfile = false;
  let viewAccumulators = false;
  const userTypeCheck = store.getState().user?.userData?.UserType;

  if (
    MasterPermissions.permissionFramework &&
    MasterPermissions.permissionFramework?.length === 0
  ) {
    viewClaim = true;
    txnDetails = true;
    viewCoverage = true;
    viewMemRec = true;
    viewIdCards = true;
    viewDocument = true;
    viewProfile = true;
  }

  if (MasterPermissions.CheckPermission('View Member Record'))
    viewMemRec = true;

  if (
    userTypeCheck != 'Provider' &&
    MasterPermissions.CheckPermission('View Coverage Details') &&
    (MasterPermissions.CheckPermission('Medical Coverage') ||
      MasterPermissions.CheckPermission('Dental Coverage') ||
      MasterPermissions.CheckPermission('Vision Coverage') ||
      MasterPermissions.CheckPermission('Prescription Coverage') ||
      MasterPermissions.CheckPermission('Long Term Disability Coverage') ||
      MasterPermissions.CheckPermission('Short Term Disability Coverage') ||
      MasterPermissions.CheckPermission('Supplemental Coverage'))
  )
    viewCoverage = true;

  if (MasterPermissions.CheckPermission('View Claims')) viewClaim = true;

  if (
    userTypeCheck != 'Provider' &&
    MasterPermissions.CheckPermission('View Spending Account Details')
  )
    txnDetails = true;

  if (
    userTypeCheck != 'Provider' &&
    MasterPermissions.CheckPermission('View ID Cards')
  )
    viewIdCards = true;

  if (MasterPermissions.CheckPermission('View Document')) viewDocument = true;

  if (
    userTypeCheck != 'Provider' &&
    MasterPermissions.CheckPermission('View Accumulators')
  ) {
    viewAccumulators = true;
  }

  if (
    (userTypeCheck != 'Provider' &&
      MasterPermissions.CheckPermission('View Self Profile Information')) ||
    MasterPermissions.CheckPermission(' View Dependent Profile Information') ||
    MasterPermissions.CheckPermission('View HIPAA Patient Rights Information')
  )
    viewProfile = true;

  useEffect(() => {
    setisAccountsVisible(false);
    const feature = FEATURES?.find(
      (feature) => feature.Name === 'spendingAccount',
    );
    if (feature && feature.Status === false) {
      setisAccountsVisible(true);
    }
    getUserInformation(props.memberOid);
  }, [props.memberOid]);

  useEffect(() => {
    const feature = FEATURES?.find(
      (feature) => feature.Name === 'SendDocument',
    );
    if (feature && feature.Status === true && viewDocument) {
      setIsDocumentVisible(true);
    }
  }, []);

  useEffect(() => {
    const feature = FEATURES?.find(
      (feature) => feature.Name === 'BenefitAccumulator',
    );
    if (feature && feature.Status === true) {
      setIsBenefitAccumsVisible(true);
    }
  }, []);

  const getUserInformation = async () => {
    const getUser = await Promise.all([GetUser()]);
  };

  const setUserTab = (name) => {
    sessionStorage.setItem('user-tab', name);
    //Clearing previous claims store
    dispatch(resetActiveUser());
    dispatch(resetSearchParams());
    dispatch(resetClaimsResult());
  };

  const GetUser = async () => {
    setLoadingGetUser(true);
    try {
      //const responseOld = await axiosInstance(
      //APIEndpoints.GetMember() + props.memberType + '/oid/' + props.memberOid,
      //);
      const response = await getMemberDetailsByOidAndType(
        props.memberOid,
        props.memberType,
      );
      console.log('182 182 182 182 182 >>>>>', response);
      getUserDataResp = response.data;

      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        dispatch(
          setSelectedMember({
            ID: getUserDataResp.Response.Member.OID,
            mType: getUserDataResp.Response.MemberType,
            label: getUserDataResp.Response.MemberType,
          }),
        );
        CookiesService.set('UserOid', getUserDataResp.Response.Member.OID);
        CookiesService.set('MemberOid', getUserDataResp.Response.Member.OID);
        CookiesService.set(
          'MemberUserType',
          getUserDataResp.Response.MemberType,
        );
        CookiesService.remove('MemberName');
        CookiesService.set(
          'MemberName',
          getUserDataResp.Response.Member.FirstName +
            ' ' +
            getUserDataResp.Response.Member.LastName,
        );
        CookiesService.set('MemberID', props.userEmail);

        RetryAPI.resetRetryCount();
        RetryAPI.setResponseReceived(true);
        getMemberID(getUserDataResp.Response.Member);
        setLoadingGetUser(false);
        setCustomError(false);
      } else {
        RetryAPI.setResponseReceived(false);
        RetryAPI.setErrorCode(response?.status);
        setLoadingGetUser(false);
        const errorCode = RetryAPI.getErrorCode();
        if (
          HttpErrorHandler.ProcessedException(
            errorCode,
            'We are unable to get user details now.',
          )
        ) {
          //setServerError(true);
          setCustomError(true);
        }
      }
    } catch (error) {
      let errorMessage = '';
      //var requestAborted = '';
      RetryAPI.setResponseReceived(false);
      setLoadingGetUser(false);
      RetryAPI.setErrorCode(error?.response?.status);
      const errorCode = RetryAPI.getErrorCode();
      console.log('Get User Exception: ', error);
      if (error) {
        errorMessage = error.toString();
        //requestAborted = errorMessage.match(/aborted/i);
        RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
      }
      if (error.response) {
        RetryAPI.setErrorCode(error.response.status);
      }

      //if (axios.isCancel(error)) {
      //console.log('Previous request canceled, new request is send', error.message);
      //}

      if (
        HttpErrorHandler.ProcessedException(
          errorCode,
          'We are unable to get user details now.',
        )
      ) {
        //setServerError(true);
        setCustomError(true);
      }
    }
  };

  const getMemberID = (memberDetails) => {
    const key =
      DefaultMemberIDKey &&
      DefaultMemberIDKey.charAt(0).toUpperCase() + DefaultMemberIDKey.slice(1);
    setMemberID(memberDetails[key]);
  };

  const enrollmentHandler = () => {
    console.log('Enrollment clicked ::::  ');
    navigate({ pathname: '/admin/enrollment-life-event' });
  };

  return (
    <div className="usermanager-info member-mgt-container 456">
      {loadingGetUser && <AllMemberDetailsSkeleton />}

      {!loadingGetUser && !clientError && !customError && getUserDataResp && (
        <div>
          <div className="usergrp-br">
            <Row>
              <Col md={2}>
                <span className="mgt-user-icon-img-large">
                  {getUserDataResp.Response.Member.FirstName.charAt(0) +
                    getUserDataResp.Response.Member.LastName.charAt(0)}
                </span>
              </Col>
              <Col md={5}>
                <h3>
                  {capitalizeFirstLetter(
                    getUserDataResp.Response.Member.FirstName,
                  )}
                  &nbsp;
                  {capitalizeFirstLetter(
                    getUserDataResp.Response.Member.LastName,
                  )}
                </h3>
              </Col>

              {viewMemRec && (
                <Col md={5}>
                  <Feature name="EnrollmentLifeChangeEventAdmin">
                    {MasterPermissions.CheckPermission('Perform Enrollment') &&
                      getUserDataResp.Response.MemberType ==
                        USER_TYPES.EMPLOYEE && (
                        <div className="quick-menu-container">
                          <ActionMenus
                            ref={memberActionMenusRef}
                            enrollmentHandler={enrollmentHandler}
                            otherActionItems={false}
                          />
                        </div>
                      )}
                  </Feature>
                  <ul className="memberDetails">
                    {getUserDataResp.Response.MemberType == 'Dependent' ? (
                      CookiesService.get('Superuser') === 'true' ||
                      (userData?.UserType == 'Insurer' &&
                        MasterPermissions.CheckPermission('View Member ID')) ? (
                        <>
                          {memberID ? (
                            <li>
                              {t(
                                'admin.pages.manage_member.dependent_member_id',
                              )}
                              <p>{memberID}</p>
                            </li>
                          ) : null}
                          {/*<li>{ t( 'admin.pages.manage_member.member_id' ) }<p>{ getUserDataResp.Response.Member.MemberCertificateNumber ? getUserDataResp.Response.Member.MemberCertificateNumber : noValue }</p></li> */}
                        </>
                      ) : memberID ? (
                        <li>
                          {t('admin.pages.manage_member.dependent_member_id')}
                          <p>{memberID}</p>
                        </li>
                      ) : null
                    ) : memberID ? (
                      <li>
                        {t('admin.pages.manage_member.member_id')}
                        <p>{memberID}</p>
                      </li>
                    ) : null}

                    <li>
                      {t('admin.pages.manage_member.user_type')}
                      <p>
                        {getUserDataResp.Response.MemberType
                          ? getUserDataResp.Response.MemberType
                          : noValue}
                      </p>
                    </li>
                    <li>
                      {t('admin.pages.manage_member.employer')}
                      <p>
                        {getUserDataResp.Response.Member.ClientName
                          ? getUserDataResp.Response.Member.ClientName
                          : noValue}
                      </p>
                    </li>
                    <li>
                      {t('admin.pages.manage_member.location')}
                      <p>
                        {getUserDataResp.Response.Member.LocationName
                          ? getUserDataResp.Response.Member.LocationName
                          : noValue}
                      </p>
                    </li>
                  </ul>
                </Col>
              )}
            </Row>
          </div>
          <div className="grpDivider"></div>
          <div>
            <Row className="memberData mt-50">
              <Col>
                <h3>{t('admin.pages.manage_member.active_coverages')}</h3>
              </Col>
            </Row>
            <div className="d-flex flex-wrap">
              {viewCoverage && (
                <div className="col-arrange">
                  <div className="memberBox">
                    <Link
                      to={'/admin/view-member'}
                      state={{
                        searchText: props.searchText,
                        pageSize: props.pageSize,
                        activePage: props.activePage,
                        isRegistered: props.isRegisterd,
                        userIndex: props.userIndex,
                        selectedUserEmail: props.userEmail,
                        selectedUserFirstName:
                          getUserDataResp.Response.Member.FirstName,
                        selectedUserLastName:
                          getUserDataResp.Response.Member.LastName,
                        isAdvanceSearch: props.isAdditionalSearch,
                        additionalSearchValues: props.additionalSearchValues,
                      }}
                    >
                      <div onClick={() => setUserTab('coverages')}>
                        <CoveragesSVG className="svg-icons" />
                        <span className="accums-label-text">
                          {t('admin.pages.manage_member.coverage')}
                        </span>
                      </div>
                    </Link>
                  </div>
                </div>
              )}

              {viewClaim && (
                <div className="col-arrange">
                  <div className="memberBox">
                    <Link
                      to={'/admin/view-member'}
                      state={{
                        searchText: props.searchText,
                        pageSize: props.pageSize,
                        activePage: props.activePage,
                        isRegistered: props.isRegisterd,
                        userIndex: props.userIndex,
                        selectedUserEmail: props.userEmail,
                        selectedUserFirstName:
                          getUserDataResp.Response.Member.FirstName,
                        selectedUserLastName:
                          getUserDataResp.Response.Member.LastName,
                        isAdvanceSearch: props.isAdditionalSearch,
                        additionalSearchValues: props.additionalSearchValues,
                      }}
                    >
                      <div onClick={() => setUserTab('claims')}>
                        <ClaimsSVG className="svg-icons" />
                        <span className="accums-label-text">
                          {t('admin.pages.manage_member.claims')}
                        </span>
                      </div>
                    </Link>
                  </div>
                </div>
              )}

              {txnDetails &&
                isAccountsVisible == false &&
                getUserDataResp.Response.MemberType !== 'Dependent' && (
                  <div className="col-arrange">
                    <div className="memberBox">
                      <Link
                        to={'/admin/view-member'}
                        state={{
                          searchText: props.searchText,
                          pageSize: props.pageSize,
                          activePage: props.activePage,
                          isRegistered: props.isRegisterd,
                          userIndex: props.userIndex,
                          selectedUserEmail: props.userEmail,
                          selectedUserFirstName:
                            getUserDataResp.Response.Member.FirstName,
                          selectedUserLastName:
                            getUserDataResp.Response.Member.LastName,
                          isAdvanceSearch: props.isAdditionalSearch,
                          additionalSearchValues: props.additionalSearchValues,
                        }}
                      >
                        <div onClick={() => setUserTab('acsummary')}>
                          <AccountsSVG className="svg-icons" />
                          <span className="accums-label-text">
                            {t('admin.pages.manage_member.acc_summary')}
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                )}
              {viewIdCards && (
                <div className="col-arrange">
                  <div className="memberBox">
                    <Link
                      to={'/admin/view-member'}
                      state={{
                        searchText: props.searchText,
                        pageSize: props.pageSize,
                        activePage: props.activePage,
                        isRegistered: props.isRegisterd,
                        userIndex: props.userIndex,
                        selectedUserEmail: props.userEmail,
                        selectedUserFirstName:
                          getUserDataResp.Response.Member.FirstName,
                        selectedUserLastName:
                          getUserDataResp.Response.Member.LastName,
                        isAdvanceSearch: props.isAdditionalSearch,
                        additionalSearchValues: props.additionalSearchValues,
                      }}
                    >
                      <div onClick={() => setUserTab('idcards')}>
                        <IDCardSVG className="svg-icons" />
                        <span className="accums-label-text">
                          {t('admin.pages.manage_member.id_card')}
                        </span>
                      </div>
                    </Link>
                  </div>
                </div>
              )}

              {isDocumentVisible && viewDocument && (
                <div className="col-arrange">
                  <div className="memberBox">
                    <Link
                      to={'/admin/view-member'}
                      state={{
                        searchText: props.searchText,
                        pageSize: props.pageSize,
                        activePage: props.activePage,
                        isRegistered: props.isRegisterd,
                        userIndex: props.userIndex,
                        selectedUserEmail: props.userEmail,
                        selectedUserFirstName:
                          getUserDataResp.Response.Member.FirstName,
                        selectedUserLastName:
                          getUserDataResp.Response.Member.LastName,
                        isAdvanceSearch: props.isAdditionalSearch,
                        additionalSearchValues: props.additionalSearchValues,
                      }}
                    >
                      <div onClick={() => setUserTab('documents')}>
                        <DocumentsSVG
                          className="svg-icons"
                          parentClassName=""
                        />
                        <span className="accums-label-text">
                          {t('admin.pages.manage_member.documents')}
                        </span>
                      </div>
                    </Link>
                  </div>
                </div>
              )}
              {viewProfile &&
                ['Insurer', 'Client', 'Provider', 'Broker'].includes(
                  userData?.UserType,
                ) && (
                  <div className="col-arrange">
                    <div className="memberBox">
                      <Link
                        to={'/admin/view-member'}
                        state={{
                          searchText: props.searchText,
                          pageSize: props.pageSize,
                          activePage: props.activePage,
                          isRegistered: props.isRegisterd,
                          userIndex: props.userIndex,
                          selectedUserEmail: props.userEmail,
                          selectedUserFirstName:
                            getUserDataResp.Response.Member.FirstName,
                          selectedUserLastName:
                            getUserDataResp.Response.Member.LastName,
                          isAdvanceSearch: props.isAdditionalSearch,
                          additionalSearchValues: props.additionalSearchValues,
                        }}
                      >
                        <div onClick={() => setUserTab('profile')}>
                          <ProfileSVG className="svg-icons" />
                          <span className="accums-label-text">
                            {t('admin.pages.manage_member.view_profile')}
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                )}
              {isBenefitAccumsVisible &&
                viewAccumulators &&
                getUserDataResp.Response.MemberType !== 'Dependent' && (
                  <div className="col-arrange">
                    <div className="memberBox">
                      <Link
                        to={'/admin/view-member'}
                        state={{
                          searchText: props.searchText,
                          pageSize: props.pageSize,
                          activePage: props.activePage,
                          isRegistered: props.isRegisterd,
                          userIndex: props.userIndex,
                          selectedUserEmail: props.userEmail,
                          selectedUserFirstName:
                            getUserDataResp.Response.Member.FirstName,
                          selectedUserLastName:
                            getUserDataResp.Response.Member.LastName,
                          isAdvanceSearch: props.isAdditionalSearch,
                          additionalSearchValues: props.additionalSearchValues,
                        }}
                      >
                        <div onClick={() => setUserTab('accumulators')}>
                          <AccumulatorSVG className="svg-icons" />
                          <span className="accums-label-text">
                            {t('admin.pages.manage_member.accumulators')}
                          </span>
                        </div>
                      </Link>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      )}
      <div>
        {!loadingGetUser && clientError && (
          <CustomClientError
            CustomClasses="p-0"
            ErrorHeading="No Members found!"
            ErrorMessage="No Member found. We are unable to get member details. "
          />
        )}
        {!loadingGetUser && customError && (
          <CustomClientError
            ErrorHeading="Something went wrong with request!"
            ErrorMessage="Please try again."
          />
        )}
      </div>
    </div>
  );
};

export default AllMemberDetailsInfo;
